/** @format */
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { localesArray } from "../../features/i18n/init";
import { trackEvent } from "../../utils/analytics";

export const LocaleSwitch = () => {
	const { i18n } = useTranslation();
	const { pathname } = useLocation();

	const switchLocaleInURI = (uri: string, newLocale: string): string => {
		return uri.replace(/^\/(en|cy)/, `/${newLocale}`);
	};

	return (
		<>
			{localesArray.map(
				(locale) =>
					i18n.resolvedLanguage !== locale && (
						<Link
							key={locale}
							to={switchLocaleInURI(pathname, locale)}
							lang={locale}
							onClick={() => trackEvent("switch_language", { language: locale })}
							aria-label={locale === "cy" ? "Switch to Welsh" : "Switch to English"}
							className="bg-gray-300 rounded-md w-24 h-10 cursor-pointer text-lg font-semibold inline-flex items-center justify-center focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-600"
						>
							{locale === "en" ? "English" : "Cymraeg"}
						</Link>
					),
			)}
		</>
	);
};
